@if (open()) {
  <div class="mockup-scrim" role="dialog" aria-modal="true" aria-label="Page mockup" (click)="close.emit()">
    <div class="mockup-box" (click)="$event.stopPropagation()">
      <div class="mockup-bar">
        <div class="mockup-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="m21 15-5-5L5 21" /></svg>
          <div>
            <div class="mt-name">{{ mockupUrl() ? 'Assigned mockup' : 'Assign a mockup' }}</div>
            <div class="mt-sub">
              @if (mockupUrl()) {
                {{ pageLabel() }} · the approved design for this page
              } @else {
                {{ pageLabel() }} · choose a mockup to assign to this page
              }
            </div>
          </div>
        </div>
        <button class="mockup-close" type="button" aria-label="Close mockup" (click)="close.emit()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
        </button>
      </div>

      @if (mockupUrl()) {
        <!-- An assigned mockup: cover-fit image, hover brighten, click to open full size. -->
        <div class="mockup-body">
          <a class="mockup-shot" [href]="mockupUrl()" target="_blank" rel="noopener" aria-label="Open mockup in new tab">
            <img class="shot-img" [src]="mockupUrl()" alt="Assigned mockup for this page" />
            <span class="shot-open-hint">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" /></svg>
              Open full size
            </span>
          </a>
        </div>
      } @else {
        <!-- No mockup assigned: pick one from the round's pool to assign to this page. -->
        <div class="mockup-body picker">
          <div class="picker-controls">
            <label class="picker-label" for="mockup-pick">Mockup</label>
            <select id="mockup-pick" class="picker-select" [value]="chosen() ?? ''" (change)="onPick($event)">
              <option value="" disabled>Select a mockup…</option>
              @for (mockup of availableMockups(); track mockup) {
                <option [value]="mockup">{{ mockupLabel(mockup) }}</option>
              }
            </select>
            <button class="picker-assign" type="button" [disabled]="!chosen() || assigning()" (click)="confirmSelection()">
              {{ assigning() ? 'Assigning…' : 'Assign to this page' }}
            </button>
          </div>
          <div class="picker-preview">
            @if (chosen(); as selectedMockup) {
              <img class="preview-img" [src]="selectedMockup" alt="Mockup preview" />
            } @else {
              <div class="picker-empty">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="m21 15-5-5L5 21" /></svg>
                <span>Select a mockup above to preview it.</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
